import type { ProductLogoSmallProps } from "../types";

/**
 * 小サイズのBusinessOperationEventsロゴアイコン
 */
export function ProductLogoSmallBusinessOperationEvents({
  size = 20,
  color = "#646467",
  ...props
}: ProductLogoSmallProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 21 20"
      fill="none"
      {...props}
    >
      <path
        d="M1.60352 2.5C1.60352 1.94772 2.05123 1.5 2.60352 1.5H6.10352C6.6558 1.5 7.10352 1.94772 7.10352 2.5V5C7.10352 5.55228 6.6558 6 6.10352 6H2.60352C2.05123 6 1.60352 5.55228 1.60352 5V2.5Z"
        fill={color}
      />
      <path
        d="M13.1035 15C13.1035 14.4477 13.5512 14 14.1035 14H17.6035C18.1558 14 18.6035 14.4477 18.6035 15V17.5C18.6035 18.0523 18.1558 18.5 17.6035 18.5H14.1035C13.5512 18.5 13.1035 18.0523 13.1035 17.5V15Z"
        fill={color}
      />
      <path
        d="M7.60352 8.75C7.60352 8.19772 8.05123 7.75 8.60352 7.75H11.6035C12.1558 7.75 12.6035 8.19772 12.6035 8.75V11.25C12.6035 11.8023 12.1558 12.25 11.6035 12.25H8.60352C8.05123 12.25 7.60352 11.8023 7.60352 11.25V8.75Z"
        fill={color}
      />
      <path
        d="M18.1035 3C18.3797 3 18.6035 3.22386 18.6035 3.5V4C18.6035 4.27614 18.3797 4.5 18.1035 4.5L8.60352 4.5C8.32737 4.5 8.10352 4.27614 8.10352 4V3.5C8.10352 3.22386 8.32737 3 8.60352 3L18.1035 3Z"
        fill={color}
      />
      <path
        d="M11.6035 16C11.8797 16 12.1035 16.2239 12.1035 16.5V17C12.1035 17.2761 11.8797 17.5 11.6035 17.5H2.60352C2.32737 17.5 2.10352 17.2761 2.10352 17L2.10352 16.5C2.10352 16.2239 2.32737 16 2.60352 16L11.6035 16Z"
        fill={color}
      />
      <path
        d="M6.10352 9.5C6.37966 9.5 6.60352 9.72386 6.60352 10V10.5C6.60352 10.7761 6.37966 11 6.10352 11L2.10352 11C1.82737 11 1.60352 10.7761 1.60352 10.5L1.60352 10C1.60352 9.72386 1.82737 9.5 2.10352 9.5H6.10352Z"
        fill={color}
      />
      <path
        d="M18.1035 9.5C18.3797 9.5 18.6035 9.72386 18.6035 10V10.5C18.6035 10.7761 18.3797 11 18.1035 11L14.1035 11C13.8274 11 13.6035 10.7761 13.6035 10.5V10C13.6035 9.72386 13.8274 9.5 14.1035 9.5H18.1035Z"
        fill={color}
      />
      <path
        d="M18.6035 3.5C18.6035 3.22386 18.3797 3 18.1035 3H17.6035C17.3274 3 17.1035 3.22386 17.1035 3.5V10.5C17.1035 10.7761 17.3274 11 17.6035 11H18.1035C18.3797 11 18.6035 10.7761 18.6035 10.5V3.5Z"
        fill={color}
      />
      <path
        d="M3.10352 10C3.10352 9.72386 2.87966 9.5 2.60352 9.5L2.10352 9.5C1.82737 9.5 1.60352 9.72386 1.60352 10L1.60352 17C1.60352 17.2761 1.82737 17.5 2.10352 17.5H2.60352C2.87966 17.5 3.10352 17.2761 3.10352 17V10Z"
        fill={color}
      />
    </svg>
  );
}
